import styles from './Related.module.scss';
import { useContext, useEffect, useState, useRef } from 'react';
import SwiperCore, { Autoplay, FreeMode, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { useRouter } from "next/dist/client/router";


SwiperCore.use([Autoplay, Pagination, Navigation, FreeMode]);

const Related = ({ related, margin }) => {
  const router = useRouter();
  if(!related || related.length == 0) return <></>;
  let lang = 'en';
  try {
    lang = router.query.locale;
  } catch(e) {}

  let title = "You might also be interested in";
  switch(lang) {
    case "en": title = "You might also be interested in"; break;
    case "it": title = "Potrebbe interessarti anche"; break;
    case "fr": title = "Cela pourrait également vous intéresser"; break;
    case "kr": title = "다음도 관심있을 수 있습니다"; break;
    case "jp": title = "あなたも興味があるかもしれません"; break;
    case "ru": title = "Вас также может заинтересовать"; break;
    case "zh": title = "你可能也感兴趣"; break;
  }
  return <div className={styles.relatedContainer} {...(margin !== undefined ? {style: { marginTop: margin}} : null )}>
    <div className={styles.containerTitle}>{title}</div>
    <Swiper slidesPerView={1}
              spaceBetween={30}
              slideToClickedSlide={true}
              // loop
              navigation
              breakpoints={{
                780: {
                  slidesPerView: 3
                }
              }}>
    {related?.map( (r,i) => 
      <SwiperSlide key={i}>
        <a className={styles.slideItem} target={r.link?.target ? r.link?.target : undefined} rel={r.link?.target ? 'noreferrer' : undefined} href={r.link?.url ? r.link?.url : undefined}>
          <img src={r.image} />
          <div className={styles.title}>{r.title}</div>
        </a>
      </SwiperSlide>)}
    </Swiper>
  </div>
}

/*Related.getInitialProps = async (context) => {
 
  let dataContent = null;
  const { slug } = context.query

  const baseUrl = process.env.NEXT_PUBLIC_DATA_BASEURL;
  try {
  let resRelated = await fetch(baseUrl + '/related/?ids=2507');
  }
  catch(e)
   { console.log(e)}
console.log(baseUrl + '/related/?ids=2507')
  let related = await resRelated.json();
  
  if (related) {
    dataContent = related;
  }

  return {
    related: related
  }
}*/
export default Related;